import {
  makeStyles,
  tokens,
  Text,
  Avatar,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  MenuDivider,
  Button,
} from '@fluentui/react-components';
import {
  PersonRegular,
  SignOutRegular,
  SettingsRegular,
} from '@fluentui/react-icons';
import { useAuth } from '../../hooks/useAuth';
import { APP_NAME } from '../../config/constants';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '48px',
    backgroundColor: '#0078d4',
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    boxShadow: tokens.shadow4,
    zIndex: 1000,
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
  logo: {
    width: '32px',
    height: '32px',
    backgroundColor: 'white',
    borderRadius: tokens.borderRadiusMedium,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    color: '#0078d4',
    fontSize: '14px',
  },
  title: {
    color: 'white',
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase400,
  },
  userSection: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
  userName: {
    color: 'white',
    fontSize: tokens.fontSizeBase200,
  },
  avatarButton: {
    cursor: 'pointer',
    padding: 0,
    minWidth: 'auto',
    backgroundColor: 'transparent',
    border: 'none',
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
});

export function Header() {
  const styles = useStyles();
  const { user, logout, isAdmin } = useAuth();

  return (
    <header className={styles.header}>
      <div className={styles.brand}>
        <div className={styles.logo}>HR</div>
        <Text className={styles.title}>{APP_NAME}</Text>
      </div>

      <div className={styles.userSection}>
        {user && (
          <>
            <Text className={styles.userName}>
              {user.name}
              {isAdmin && ' (Admin)'}
            </Text>
            <Menu>
              <MenuTrigger disableButtonEnhancement>
                <Button
                  className={styles.avatarButton}
                  appearance="transparent"
                  icon={
                    <Avatar
                      name={user.name}
                      size={32}
                      color="colorful"
                    />
                  }
                />
              </MenuTrigger>
              <MenuPopover>
                <MenuList>
                  <MenuItem icon={<PersonRegular />}>
                    {user.email}
                  </MenuItem>
                  <MenuItem icon={<SettingsRegular />} disabled>
                    Settings
                  </MenuItem>
                  <MenuDivider />
                  <MenuItem icon={<SignOutRegular />} onClick={logout}>
                    Sign out
                  </MenuItem>
                </MenuList>
              </MenuPopover>
            </Menu>
          </>
        )}
      </div>
    </header>
  );
}
